import { useState } from "react";
import { CircularProgress, Drawer, useMediaQuery } from "@mui/material";
import Header from "../Header/Header";
import style from "./Dashboard.module.scss";
import { Routes, Route } from "react-router-dom";
import Menu from "../Menu/Menu";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import FormsTable from "../Forms/FormsTable";
import Reports from "../Reports/Reports";
import Users from "../Users/Users";
import HomePage from "./HomePage";

const useStyles = makeStyles(() => ({
  content: {
    marginLeft: 0,
    position: "absolute",
    height: "100%",
    width: "100%",
  },
  contentShift: {
    marginLeft: 340,
    width: "calc(100% - 340px)",
  },
}));

function DashboardAdmin() {
  const classes = useStyles();
  const matches = useMediaQuery("(max-width:600px)");
  const [openMenu, setOpenMenu] = useState(matches ? false : true);
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <Drawer
        classes={{
          root: style.drawerRoot,
          paper: style.drawerPaper,
        }}
        variant={matches ? "temporary" : "persistent"}
        anchor="left"
        open={openMenu}
      >
        <Menu
          isMobile={matches}
          menuButtonClick={() => {
            setOpenMenu(!openMenu);
          }}
        />
      </Drawer>
      <div
        className={clsx(classes.content, {
          [classes.contentShift]: openMenu,
        })}
      >
        <Header
          menuButtonClick={() => {
            setOpenMenu(!openMenu);
          }}
        />
        <Routes>
          <Route
            path="/"
            element={<FormsTable />}
          />
          <Route
            path="/reports"
            element={<Reports setLoading={setLoading} />}
          />
          <Route path="/users" element={<Users />} />
          <Route
            path="/forms"
            element={
              <div className={style.dashboardBackground}>
                <HomePage />
              </div>
            }
          />
        </Routes>
      </div>
      {loading ? (
        <div className={style.loading}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default DashboardAdmin;
